import React, { memo, forwardRef } from "react";
const SvgCapitalX = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.54 21.06c.16.227.267.413.32.56.053.147.08.287.08.42 0 .36-.127.653-.38.88-.24.227-.54.34-.9.34-.16 0-.34-.04-.54-.12-.187-.08-.387-.273-.6-.58l-3.58-5.1-3.52 5.12c-.2.293-.4.48-.6.56-.2.08-.38.12-.54.12-.347 0-.64-.113-.88-.34a1.165 1.165 0 01-.34-.86c0-.133.027-.273.08-.42.053-.16.16-.353.32-.58l3.96-5.54-3.46-4.62a2.241 2.241 0 01-.32-.54 1.278 1.278 0 01-.08-.44c0-.333.113-.613.34-.84.24-.227.533-.34.88-.34.16 0 .333.04.52.12.2.08.4.26.6.54l3.14 4.42 3.04-4.42c.2-.28.393-.46.58-.54.187-.08.36-.12.52-.12.333 0 .607.107.82.32.227.2.34.473.34.82 0 .12-.027.26-.08.42-.04.147-.133.313-.28.5l-3.42 4.78 3.98 5.48z"
      />
    </svg>
  );
});
SvgCapitalX.displayName = "SvgCapitalX";
const MemoForwardRef = memo(SvgCapitalX);
export default MemoForwardRef;
